import { Injectable } from '@angular/core';
import { GridDisplaySettings } from '@app/models';
import {
  SaveUserGridConfigurationFail,
  SetUserGridConfiguration,
  UnsupportedUserGridType
} from '@app/pcs/actions/user-grid-configuration';
import { UserGridConfiguration } from '@app/pcs/models/user-grid-configuration';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import { UserGridConfigurationDataService } from '@app/pcs/services/user-grid-configuration-data.service';
import { updateGridDisplaySettings, updateGridDisplaySettingsForColumns } from '@app/pcs/util';
import { fromJson, isNotNil, toJsonString } from '@util';
import { iif, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class UserGridConfigurationService {

  updateForColumns(columns, gridName, gridConfig) {
    return iif(() => isNotNil(gridName),
      this.saveConfiguration(gridName, updateGridDisplaySettingsForColumns(columns, gridConfig)),
      of(new UnsupportedUserGridType())
    );
  }

  updateForColumn(updatedColumn, gridName, gridConfig) {
    return iif(() => isNotNil(gridName),
      this.saveConfiguration(gridName, updateGridDisplaySettings(updatedColumn, gridConfig)),
      of(new UnsupportedUserGridType())
    );
  }

  private saveConfiguration(type: UserGridType, gridConfig: GridDisplaySettings) {
    const configuration: UserGridConfiguration = {
      type: {id: type},
      configuration: toJsonString(gridConfig)
    };

    return this.userGridConfigurationDataService.save(configuration).pipe(
      switchMap((response: UserGridConfiguration) => of(
        new SetUserGridConfiguration({
          userGridType: type,
          configuration: fromJson(response.configuration)
        }))
      ),
      catchError(error => of(new SaveUserGridConfigurationFail(error)))
    );
  }

  constructor(
    private userGridConfigurationDataService: UserGridConfigurationDataService
  ) {
  }
}
